import styled from 'styled-components'

type SeparatorProps = {
  maxWidth?: number
  height?: number
  color?: string
  isCentered?: boolean
}

export const Container = styled.div<SeparatorProps>`
  position: relative;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  max-width: ${({ theme }) => `${theme.sizes.boxContent / 10}rem`};
  height: 0;
  overflow: visible;
  margin-left: auto;
  margin-right: auto;
`

export const Bar = styled.hr<SeparatorProps>`
  height: 0;
  border: 0;
  border-top: ${({ height }) => (height ? `${height / 10}rem` : '0.2rem')} solid;
  border-color: ${({ color, theme }) =>
    color ? color : theme.colors.greyDD ?? 'lightgrey'};
  margin: 0 ${({ isCentered }) => (isCentered === true ? 'auto' : '0')};
  max-width: ${({ maxWidth }) =>
    maxWidth && maxWidth !== 0 ? `${maxWidth / 10}rem` : 'none'};
`
